/**
 * Shared labels and helpers for épaysage intervention essence sections (web + PDF).
 * Labels aligned with packages/field-configs/src/epaysage/essence/fields.json (preconisation-de-travaux freeforms).
 */

export type TravauxEssenceWebProp =
  | 'travauxAbattage'
  | 'travauxDemontage'
  | 'travauxMiseEnSecurite'
  | 'travauxTailleSanitaire'
  | 'travauxDechiffrage'
  | 'travauxCoupleSelective';

export type TravauxEssenceApiField =
  | 'travaux_abattage'
  | 'travaux_demontage'
  | 'travaux_mise_en_securite'
  | 'travaux_taille_sanitaire'
  | 'travaux_dechiffrage'
  | 'travaux_couple_selective';

export interface TravauxEssenceDetailRow {
  readonly label: string;
  readonly webProp: TravauxEssenceWebProp;
  readonly apiField: TravauxEssenceApiField;
}

export const TRAVAUX_ESSENCE_DETAIL_ROWS: ReadonlyArray<TravauxEssenceDetailRow> =
  [
    { label: 'Abattage  :', webProp: 'travauxAbattage', apiField: 'travaux_abattage' },
    { label: 'Démontage : ', webProp: 'travauxDemontage', apiField: 'travaux_demontage' },
    {
      label: 'Mise en sécurité :',
      webProp: 'travauxMiseEnSecurite',
      apiField: 'travaux_mise_en_securite',
    },
    {
      label: 'Taille sanitaire :',
      webProp: 'travauxTailleSanitaire',
      apiField: 'travaux_taille_sanitaire',
    },
    { label: 'Défrichage :', webProp: 'travauxDechiffrage', apiField: 'travaux_dechiffrage' },
    {
      label: 'Coupe Sélective de sujets :',
      webProp: 'travauxCoupleSelective',
      apiField: 'travaux_couple_selective',
    },
  ];

export function isNonEmptyTravauxValue(value: string | null | undefined): boolean {
  if (value == null) return false;
  return String(value).trim().length > 0;
}

/**
 * Numeric value often as string: > 1 → « sujets », else « sujet ».
 * If non-numeric, default to « sujets ».
 */
export function formatValueWithSujetLabel(raw: string): string {
  const trimmed = raw.trim();
  const n = Number.parseFloat(trimmed.replace(',', '.'));
  if (Number.isNaN(n)) {
    return `${trimmed} sujets`;
  }
  const mot = n > 1 ? 'sujets' : 'sujet';
  return `${trimmed} ${mot}`;
}
